<form 
  *ngIf="form()"
  [formGroup]="form()!" 
  (ngSubmit)="onSubmit()"
  class="space-y-6 "
>
  <!-- First Name - Only for PERSON type -->
  @if (isPersonType) {
    <div class="flex gap-5">
      <div class="w-full">
        <label for="firstName" >Nombre</label>
        <input 
          type="text" 
          id="firstName" 
          formControlName="firstName"
          class="input__base"
        />
        <app-input-error [control]="form()!.get('firstName')" [submitted]="submitted()" />
      </div>

      <!-- Last Name - Only for PERSON type -->
      <div class="w-full">
        <label for="lastName" >Apellido</label>
        <input 
          type="text" 
          id="lastName" 
          formControlName="lastName"
          class="input__base"
        />
        <app-input-error [control]="form()!.get('lastName')" [submitted]="submitted()" />
      </div>
    </div>
    
  }

  <!-- Company Name - Only for COMPANY type -->
  @if (isCompanyType) {
    <div class="">
      <label for="companyName" >Razón Social</label>
      <input 
        type="text" 
        id="companyName" 
        formControlName="companyName"
        class="input__base"
      />
      <app-input-error [control]="form()!.get('companyName')" [submitted]="submitted()" />
    </div>
  }

  <!-- Identification and grossIncomeCondition/birthDate -->
  <div class="flex gap-5">
    <!-- Identification -->
    <div class="w-full">
      <label for="identification" >{{ identificationLabel }}</label>
      @if (isCompanyType) {
        <input
          type="text"
          id="identification"
          formControlName="identification"
          class="input__base"
          [mask]="identificationMask"
          cuitBlurNormalize
        />
      } @else {
        <input
          type="text"
          id="identification"
          formControlName="identification"
          class="input__base"
          [mask]="identificationMask"
        />
      }
      <app-input-error [control]="form()!.get('identification')" [submitted]="submitted()" />
    </div>

    <!-- Gross Income Condition - Only for COMPANY type -->
    @if (isCompanyType) {
      <div class="w-full">
        <label for="grossIncomeCondition">Condición de ingresos brutos</label>
        <select 
          id="grossIncomeCondition" 
          formControlName="grossIncomeCondition"
          class="input__base"
        >
          <option value="" disabled>Seleccionar condición</option>
          <option [value]="GROSS_INCOME_CONDITION.MULTILATERAL_AGREEMENT">{{ GROSS_INCOME_CONDITION.MULTILATERAL_AGREEMENT }}</option>
          <option [value]="GROSS_INCOME_CONDITION.LOCAL">{{ GROSS_INCOME_CONDITION.LOCAL }}</option>
          <option [value]="GROSS_INCOME_CONDITION.NOT_REGISTERED_IN_IIBB">{{ GROSS_INCOME_CONDITION.NOT_REGISTERED_IN_IIBB }}</option>
          <option [value]="GROSS_INCOME_CONDITION.EXEMPT">{{ GROSS_INCOME_CONDITION.EXEMPT }}</option>
          <option [value]="GROSS_INCOME_CONDITION.NOT_REACHED">{{ GROSS_INCOME_CONDITION.NOT_REACHED }}</option>
        </select>
        <app-input-error [control]="form()!.get('grossIncomeCondition')" [submitted]="submitted()" />
      </div>
    }

    <!-- Birth Date - Only for PERSON type -->
    @if (isPersonType) {
      <div class="w-full">
        <label for="birthDate">Fecha de nacimiento</label>
        <input 
          type="date" 
          id="birthDate" 
          formControlName="birthDate"
          class="input__base"
        />
        <app-input-error [control]="form()!.get('birthDate')" [submitted]="submitted()" />
      </div>
    }
  </div>

  <!-- Email - For all user types -->
  <div class="">
    <label for="email">Email</label>
    <input 
      type="email" 
      id="email" 
      formControlName="email"
      class="input__base"
      placeholder="ejemplo@correo.com"
    />
    <app-input-error [control]="form()!.get('email')" [submitted]="submitted()" />
  </div>

  <div class="flex gap-5">

    <!-- Address - Using input-address component -->
    <div class="w-full">
      <app-input-address
        formControlName="address"
        [label]="'Buscar dirección'"
        [submitted]="submitted()"
      ></app-input-address>
      <app-input-error [control]="form()!.get('address')" [submitted]="submitted()" />
    </div>
    <!-- Postal Code -->
    <div class="w-full">
      <label for="postalCode" >Código Postal</label>
      <input 
        type="text" 
        id="postalCode" 
        formControlName="postalCode"
        class="input__base"
        maxlength="4"
        (change)="checkPostalCode()"
      />
      <app-input-error [control]="form()!.get('postalCode')" [submitted]="submitted()" />
      
      <!-- Hidden zoneId input -->
      <input type="hidden" formControlName="zoneId" />
      
      <!-- Zone selection for multiple zones -->
      @if (zones().length > 1) {
        <div class="mt-2">
          <label for="zone-select">Selecciona la zona</label>
          <select
            id="zone-select"
            class="input__base mt-1"
            [class.error]="submitted() && !selectedZone()"
            (change)="onZoneSelect($event)">
            <option value="">Selecciona una zona</option>
            @for (zone of zones(); track zone.id) {
              <option [value]="zone.id">{{ zone.name }} - {{ zone.province.name }}</option>
            }
          </select>
          @if (submitted() && !selectedZone()) {
            <div class="text-red-500 text-sm mt-1">Debe seleccionar una zona.</div>
          }
        </div>
      }
      
      <!-- Loading indicator -->
      @if (checkingPostalCode()) {
        <div class="text-sm text-gray-600 mt-2">
          Verificando código postal...
        </div>
      }
    </div>

  </div>
 

  <!-- Submit Button -->
  <div class="flex justify-end items-end pt-4">
    <activar-button
      type="submit"
      text="Continuar"
      [loadingText]="'Actualizando...'"
      [loading]="loading()"
      [disabled]="loading()"
      fill="solid"
      color="primary"
      expand="block"
    />
  </div>
</form>